/*
 * Header JS.
 *
 * @type {Object}
 */
const headerHub = {
	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.header = document.getElementById( 'site-hub-header' );

		this.burgerMenu = document.getElementById(
			'primary-header__menu-button'
		);

		this.mobileMenu = document.getElementById( 'site-navigation' );

		this.subMenuIcons = document.querySelectorAll(
			'.menu-item-has-children > a'
		);

		// Sticky Bar Element
		this.stickyBar = document.getElementById( 'sticky-bar' );

		// Only proceed if required elements exist
		if ( this.header ) {
			this.addEvents();
			this.focusPrimaryMenu();
		}
	},

	/**
	 * Add events.
	 *
	 * @return {void}
	 */
	addEvents() {
		// Scroll events
		window.addEventListener( 'scroll', () => {
			if ( this.header ) {
				this.hideTopMenu();
			}
			if ( this.stickyBar ) {
				this.toggleStickyBar();
			}
		} );

		// Burger menu events
		if ( this.burgerMenu && this.mobileMenu ) {
			this.burgerMenu.addEventListener( 'click', () => this.moveBurgerMenu() );
		}

		// Close menu on clicking a menu item if it's an anchor link to the same page
		if (this.mobileMenu) {
			this.mobileMenu.addEventListener('click', (event) => {
				const link = event.target.closest('a');
				if (!link) return;

				const href = link.getAttribute('href');

				// Check if the link is an anchor link and belongs to the same page
				if (href && href.startsWith('#')) {
					this.closeMobileMenu();
				} else {
					const linkUrl = new URL(link.href, window.location.origin);
					if (linkUrl.origin === window.location.origin && linkUrl.pathname === window.location.pathname) {
						// If it's the same page but has an anchor
						if (linkUrl.hash) {
							this.closeMobileMenu();
						}
					}
				}
			});
		}
	
		// Resize events
		window.addEventListener( 'resize', () => {
			if ( window.innerWidth >= 1025 ) {
				this.closeMobileMenu();
			}
		} );
	},

	/**
	 * Hides top Menu.
	 *
	 * @return {void}
	 */
	hideTopMenu() {
		if ( ! this.header ) {
			return;
		}

		if ( 100 <= window.scrollY ) {
			this.header.classList.add( 'site-header--is-scrolling' );
		} else {
			this.header.classList.remove( 'site-header--is-scrolling' );
		}
	},

	/**
	 * Toggle Sticky Bar visibility.
	 *
	 * @return {void}
	 */
	toggleStickyBar() {
		if ( ! this.header || ! this.stickyBar ) {
			return;
		}

		const headerHeight = this.header.offsetHeight;

		// Check if the user has scrolled past the header
		if ( window.pageYOffset > headerHeight ) {
			this.stickyBar.classList.add( 'show-sticky' ); // Show sticky bar
		} else {
			this.stickyBar.classList.remove( 'show-sticky' ); // Hide sticky bar
		}
	},

	/**
	 * Moves Burger Menu.
	 *
	 * @return {void}
	 */
	moveBurgerMenu() {
		if ( ! this.burgerMenu || ! this.mobileMenu ) {
			return;
		}

		this.burgerMenu.classList.toggle( 'primary-header__menu-button--close' );
		this.mobileMenu.classList.toggle( 'mobile-main-menu--displayed' );
		document.body.classList.toggle( 'disable-hub-scroll' );
	},

	/**
	 * Remove Burger Menu class to close mobile menu.
	 *
	 * @return {void}
	 */
	closeMobileMenu() {
		if ( ! this.burgerMenu || ! this.mobileMenu ) {
			return;
		}

		if ( this.mobileMenu.classList.contains( 'mobile-main-menu--displayed' ) ) {
			this.burgerMenu.classList.remove( 'primary-header__menu-button--close' );
			this.mobileMenu.classList.remove( 'mobile-main-menu--displayed' );
			document.body.classList.remove( 'disable-hub-scroll' );
		}
	},

	/**
	 * Handle Debounce.
	 *
	 * @param {Function} func  The function to be debounced.
	 * @param {number}   delay The amount of delay in milliseconds.
	 *
	 * @return {Function}      It returns a new function that limits the
	 *                         rate at which the func can be invoked
	 */
	debounce( func, delay ) {
		let timer;
		return function() {
			const context = this;
			const args = arguments;
			clearTimeout( timer );
			timer = setTimeout( () => {
				func.apply( context, args );
			}, delay );
		};
	},

	/**
	 * Highlight menu on keyboard navigation.
	 *
	 * @return {boolean|void} Toggle focus class on keyboard navigation.
	 */
	focusPrimaryMenu() {
		const menu = document.querySelector( '.hub-main-navigation' );
		if ( ! menu ) {
			return false;
		}

		const links = menu.getElementsByTagName( 'a' );
		if ( ! links.length ) {
			return false;
		}

		for ( let i = 0; i < links.length; i++ ) {
			links[ i ].addEventListener( 'focus', toggleFocus, true );
			links[ i ].addEventListener( 'blur', toggleFocus, true );
			if ( links[ i ].parentElement ) {
				links[ i ].parentElement.addEventListener( 'mouseenter', removeFocusClassOnHover );
				links[ i ].parentElement.addEventListener( 'mouseleave', removeFocusClassOnHover );
			}
		}

		function toggleFocus() {
			let self = this;

			// Remove the focus class from all menu items.
			removeFocusClassFromAll();

			while ( self && self.className.indexOf( 'hub-primary-menu' ) === -1 ) {
				if ( self.tagName.toLowerCase() === 'li' ) {
					if ( self.className.indexOf( 'focus' ) !== -1 ) {
						self.className = self.className.replace( ' focus', '' );
					} else {
						self.className += ' focus';
					}
				}
				self = self.parentElement;
			}
		}

		function removeFocusClassOnHover() {
			let self = this;

			while ( self && self.className.indexOf( 'hub-primary-menu' ) === -1 ) {
				if ( self.tagName.toLowerCase() === 'li' ) {
					self.className = self.className.replace( ' focus', '' );
				}
				self = self.parentElement;
			}
		}

		function removeFocusClassFromAll() {
			const focusedItems = menu.querySelectorAll( '.focus' );
			focusedItems.forEach( ( item ) => {
				if ( item && item.className ) {
					item.className = item.className.replace( ' focus', '' );
				}
			} );
		}
	},
};

export default headerHub;
